import { VDError } from "@/models/VDError";
import { isNullEmptyOrUndefined } from "@/utils/mist";
import { ApolloError } from "@apollo/client/errors";
import { logErrorMessages } from "@vue/apollo-util";
import { computed, Ref, unref } from "vue";

function getCorrelationId(error: ApolloError): string {
  const networkError = error.networkError as any;
  let correlationId = networkError?.result?.correlationId;

  if (isNullEmptyOrUndefined(correlationId)) {
    correlationId = error.graphQLErrors[0]?.extensions?.correlationId;
  }

  return correlationId ?? "";
}

export default function (
  error: (ApolloError | null) | Ref<ApolloError | null>,
  title?: string | Ref<string | undefined>
): Ref<VDError | null> {
  return computed<VDError | null>(() => {
    const uError = unref(error);

    if (process.env.NODE_ENV !== "production" && uError) {
      logErrorMessages(uError);
    }

    if (!uError) {
      return null;
    }

    const correlationId = getCorrelationId(uError);
    const baseMessage =
      uError?.message ??
      "Vi har desværre ingen yderligere oplysninger på nuværende tidspunkt";

    return {
      title: unref(title) ?? "Der skete en fejl",
      message: correlationId
        ? `${baseMessage}\n(Korrelations-id: ${correlationId})`
        : baseMessage,
    };
  });
}
